import { useTranslation } from "react-i18next";
import * as Yup from "yup";

export const YupAdmin = () => {
  const { t } = useTranslation();
  return {
    name: Yup.string().required(
      t("validation.required", {
        name: t("page.name"),
      })
    ),
    email: Yup.string()
      .email()
      .required(
        t("validation.required", {
          email: t("page.email"),
        })
      ),
    userRole: Yup.string().required(
      t("validation.required", {
        userRole: t("page.userRole"),
      })
    ),
  };
};
